import { Reveal } from "./Reveal";
import { TRACK, DEALS } from "../../data";
import { ArrowUpRight } from "lucide-react";

export const Experience = () => {
  return (
    <section id="experience" data-testid="experience" className="relative py-28 lg:py-40 border-t border-hairline bg-surface/20">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <Reveal className="lg:col-span-7">
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">The Experience</span>
            <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-parchment mt-6 text-balance">
              Not a claim.<br />A <span className="italic text-gold">track record.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5 lg:justify-self-end">
            <p className="text-stone leading-relaxed max-w-md">
              Powered by GT Securities' proprietary DealFlo™ platform, EQ Capital Group unites experienced bankers, the right investors, and companies ready to transact — the result is more, and better, closings.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-hairline">
          {TRACK.map((t, i) => (
            <Reveal key={t.label} delay={i * 0.08} className="border-r border-b border-hairline p-8 lg:p-10">
              <div className="font-serif font-light text-5xl lg:text-6xl text-gold tracking-tight">{t.value}</div>
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone mt-3">{t.label}</div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-20">
          <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Representative Transactions</span>
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {DEALS.map((d, i) => (
              <Reveal key={d.company} delay={i * 0.06}>
                <div data-testid={`deal-${i}`} className="group border border-hairline p-8 hover:border-gold/50 hover:bg-ink transition-colors duration-500 h-full">
                  <div className="flex items-start justify-between">
                    <span className="font-serif text-3xl font-light text-parchment tracking-tight group-hover:text-gold transition-colors duration-300">{d.company}</span>
                    <ArrowUpRight size={18} className="text-stone group-hover:text-gold group-hover:rotate-45 transition-transform duration-500" />
                  </div>
                  <p className="text-stone text-sm mt-3">{d.detail}</p>
                  <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-gold/70 mt-4">{d.sector}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1} className="mt-16">
          <p className="font-serif italic text-2xl sm:text-3xl text-parchment/90 max-w-3xl leading-snug">
            "The deepest access to Ultra-High-Net-Worth investors and family offices — matched with two decades of proven execution."
          </p>
        </Reveal>
      </div>
    </section>
  );
};
